import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/** Clears every stored report configuration when a reset is requested. */
export const resetSettings = store.effects.create(
  (feature: Plugin['feature'], settingsStorage: Plugin['settingsStorage']) =>
    feature.actions.reset.relay(forwardTo =>
      rxjs.of(
        forwardTo(settingsStorage.actions.writeAllProperties, {
          input: { values: {} },
        }),
      ),
    ).asObservable,
)
